import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { request } from '../../xhr';
import { put, call } from 'redux-saga/effects';
import { putEntities } from '../../redux/entities/actions';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import { getGallectionType } from '../helpers';
import { normalizeDeviation, normalizeGallection } from '../../redux/normalizr/helpers';
function* setGallectionCover({ gallection , deviation , onlyIfMissing =false  }) {
    if (onlyIfMissing && gallection.thumb) {
        return;
    }
    // stash doesn't support custom covers
    if (gallection.type === 'stash') {
        return;
    }
    if (![
        DeviationTypes.IMAGE,
        DeviationTypes.LITERATURE
    ].includes(getDeviationType(deviation))) {
        // Only allow images and literature deviations as gallection covers
        return;
    }
    const updatedGallection = _object_spread_props(_object_spread({}, gallection), {
        thumb: deviation
    });
    const entities = normalizeGallection(updatedGallection);
    yield put(putEntities({
        entities
    }));
    var _getGallectionType;
    const params = {
        type: (_getGallectionType = getGallectionType(gallection)) !== null && _getGallectionType !== void 0 ? _getGallectionType : 'collection',
        folderid: gallection.folderId,
        name: gallection.name,
        description: gallection.description || '',
        cover_deviationid: deviation.deviationId
    };
    yield call(request, {
        method: 'post',
        url: 'gallection/folders/update',
        data: params
    });
}
export function* setGallectionCoverActionHandler(action) {
    const { gallection , deviation  } = action.payload;
    yield call(setGallectionCover, {
        gallection,
        deviation
    });
    // TODO: this should not be needed...
    const entities = normalizeDeviation(deviation);
    yield put(putEntities({
        entities
    }));
}
export default setGallectionCover;
